export function ignorePromise(promise) {
    // Based on https://github.com/typescript-eslint/typescript-eslint/blob/master/packages/eslint-plugin/docs/rules/no-floating-promises.md
    void promise;
    return;
}
